import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Shopping Guide', href: '/basetao-spreadsheet-guide' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'Shipping', href: '#shipping' },
  { label: 'Guides', href: '#guides' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-gradient-to-b from-black/40 to-transparent backdrop-blur-sm'
      }`}
    >
      <div className="w-full px-4 md:px-10">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`font-heading text-lg md:text-xl font-bold whitespace-nowrap cursor-pointer transition-colors duration-300 ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}
          >
            Basetao Spreadsheet
          </Link>

          <div className="hidden md:flex items-center gap-7">
            {navLinks.map((link) => (
              link.href.startsWith('/') ? (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-300 ${
                    scrolled ? 'text-foreground-700 hover:text-foreground-900' : 'text-white/90 hover:text-white'
                  }`}
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.href}
                  href={link.href}
                  className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-300 ${
                    scrolled ? 'text-foreground-700 hover:text-foreground-900' : 'text-white/90 hover:text-white'
                  }`}
                >
                  {link.label}
                </a>
              )
            ))}
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`whitespace-nowrap cursor-pointer px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 ${
                scrolled ? 'bg-primary-500 text-white hover:bg-primary-600' : 'bg-white text-foreground-900 hover:bg-white/90'
              }`}
            >
              Buy It Now
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-lg transition-colors duration-300 ${
              scrolled ? 'text-foreground-700' : 'text-white'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              link.href.startsWith('/') ? (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="text-foreground-700 text-sm font-medium py-3 px-3 cursor-pointer hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors"
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="text-foreground-700 text-sm font-medium py-3 px-3 cursor-pointer hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors"
                >
                  {link.label}
                </a>
              )
            ))}

            <button
              onClick={() => setMobileCatOpen(!mobileCatOpen)}
              className="flex items-center justify-between w-full text-foreground-700 text-sm font-medium py-3 px-3 cursor-pointer hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors mt-2 border-t border-background-200/70 pt-4"
            >
              <span className="flex items-center gap-2">
                <i className="ri-grid-line text-base"></i>
                Product Categories
              </span>
              <i className={`ri-arrow-down-s-line text-sm transition-transform ${mobileCatOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {mobileCatOpen && (
              <div className="grid grid-cols-2 gap-1 pl-3 pr-1 py-1">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMobileOpen(false)}
                    className="text-foreground-600 text-xs py-2 px-2 cursor-pointer hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap overflow-hidden text-ellipsis"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            )}

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap cursor-pointer mt-3 px-4 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold text-center transition-all duration-300 hover:bg-primary-600"
            >
              Buy It Now on kaspreadsheet.com
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}